module.exports = __webpack_public_path__ + "img/pro1.d2521312.png";